import styled from 'styled-components';
import { COLORS } from '../../styles/colors';
import { breakpoint } from '../../styles/constants';
import { hoverRed, redUnderline } from '../../styles/mixins';

export interface WxLabelProps {
  label: string;
  active?: boolean;
  onClick?: () => void;
  hover?: boolean;
  black?: boolean;
  id?: string;
  noUppercase?: boolean;
  small?: boolean;
  style?: any;
}

const WxLabel = ({
  active = false,
  label,
  onClick = () => {},
  black = false,
  hover = false,
  id = '',
  noUppercase = false,
  small = false,
  style,
}: WxLabelProps) => (
  <Paragraph
    id={id}
    data-active={active}
    onClick={onClick}
    $black={black}
    $hover={hover}
    $noUppercase={noUppercase}
    $small={small}
    style={style}
  >
    {label}
  </Paragraph>
);

const Paragraph = styled.p<{
  $black?: boolean;
  $hover?: boolean;
  $noUppercase: boolean;
  $small: boolean;
}>`
  text-transform: ${({ $noUppercase }) => !$noUppercase && 'uppercase'};
  font-weight: 900;
  color: ${(props) => (props.$black ? COLORS.black : COLORS.white)};
  font-size: ${({ $small }) => ($small ? '.5rem' : '.75rem')};

  @media (min-width: ${breakpoint}) {
    font-size: ${({ $small }) => ($small ? '.5rem' : '.875rem')};
  }

  &[data-active='true'] {
    ${redUnderline}
  }

  ${(props) => props.$hover && hoverRed}
`;

export default WxLabel;
